import * as Sentry from '@sentry/react';

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return;
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    // Background service-worker update checks (registerType: 'autoUpdate')
    // re-fetch /sw.js periodically. During a deploy/restart that fetch can
    // momentarily 404, surfacing as "Failed to update a ServiceWorker ...
    // Not found". Non-fatal (the installed SW keeps serving from precache)
    // and never actionable — drop it as noise.
    ignoreErrors: ['Failed to update a ServiceWorker'],
  });
}

export function sentryBreadcrumb(message: string, data?: Record<string, unknown>) {
  Sentry.addBreadcrumb({ message, data, level: 'info' });
}

export { Sentry };
